import { useEffect, useState } from "react";
import { useNewApplicantContext } from "context/NewApplicantContext";
import UploadFileModal from "layouts/pages/applicants/components/UploadFileModal";
import Attachments from "layouts/pages/applicants/components/ApplicantOnboardingPanel/Attachments";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { Button, Stack } from "@mui/material";
import { useAppContextController } from "context/AppContext";
import { getCommonBaseImageUrl } from "utils/helpers/upload";
import OnboardingGuideModal from "components/OnboardingGuideModal";

const UploadID = () => {
  const { applicant, updateButtons, buttonState, updateApplicantAction } = useNewApplicantContext();
  const { user, company, userType } = useAppContextController();
  const [attachmentOpen, setAttachmentOpen] = useState(false);
  const [guideModalOpen, setGuideModalOpen] = useState(false);

  const { complete, validIDs = [] } = applicant?.onboardingDocsComplete || {};

  const isPreHire = applicant?.applicantStatus === "Pre-Hire";
  const isComplete = complete === "Yes";
  const validUploadsMessage =
    validIDs.length > 0 ? `Valid uploads found: ${validIDs.join(", ")}` : "No valid uploads found";

  // Auto-open modal for "User" type
  useEffect(() => {
    if (userType === "User") {
      setGuideModalOpen(true);
    }
  }, [userType]);

  const attachmentTitle = (
    <>
      <Stack justifyContent="flex-start">
        {(isPreHire || !user) && (
          <MDTypography
            component="label"
            variant="button"
            fontWeight="bold"
            color={isComplete ? "success" : "error"}
          >
            {isComplete
              ? "Onboarding documents are complete."
              : "Onboarding documents are incomplete."}{" "}
            {validUploadsMessage}
          </MDTypography>
        )}
        <MDTypography component="label" variant="button" fontWeight="bold">
          You must upload clear copies of both the front and back of the government-issued
          employment authorization documents that you listed on your I-9 form
        </MDTypography>
        <MDBox sx={{ width: "100%" }}>
          <Button
            variant="text"
            sx={{
              textTransform: "none",
              color: "info",
              textDecoration: "underline",
              pl: 0,
              textAlign: "left",
              display: "block",
            }}
            onClick={() => {
              setGuideModalOpen(true);
            }}
          >
            Click here for onboarding documents upload guide
          </Button>
          <Button
            variant="text"
            sx={{
              textTransform: "none",
              color: "info",
              textDecoration: "underline",
              pl: 0,
              textAlign: "left",
            }}
            onClick={() => {
              window.open(
                `${getCommonBaseImageUrl(
                  company
                )}/static/How%20to%20Compress%20Your%20Images%20for%20Upload.pdf`
              );
            }}
          >
            Click here for our image upload guide
          </Button>
        </MDBox>
      </Stack>

      <hr />
    </>
  );

  useEffect(() => {
    updateButtons({
      ...buttonState,
      previous: {
        show: true,
        disabled: false,
      },
      next: {
        show: true,
        disabled: false,
      },
      submit: {
        show: true,
        disabled: false,
      },
    });
  }, []);

  return (
    <>
      <Attachments
        currentApplicant={applicant}
        setOpen={setAttachmentOpen}
        attachmentTitle={attachmentTitle}
      />
      <UploadFileModal
        currentApplicant={applicant}
        open={attachmentOpen}
        setOpen={setAttachmentOpen}
        updateApplicantAction={updateApplicantAction}
        outsideMode={user ? "" : "protected"}
        defaultAttachmentType="Onboarding_Documents"
      />
      <OnboardingGuideModal open={guideModalOpen} setOpen={setGuideModalOpen} />
    </>
  );
};

export default UploadID;
